import { render, staticRenderFns } from "./ModalEscolhaAvaliacaoPlataforma.vue?vue&type=template&id=ea346dd0&scoped=true"
import script from "./ModalEscolhaAvaliacaoPlataforma.vue?vue&type=script&lang=js"
export * from "./ModalEscolhaAvaliacaoPlataforma.vue?vue&type=script&lang=js"
import style0 from "./ModalEscolhaAvaliacaoPlataforma.vue?vue&type=style&index=0&id=ea346dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea346dd0",
  null
  
)

export default component.exports